import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Notices } from '../../core/entities/notices.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class NoticesService {
    readonly BASE: any = PETICIONES.notices;

    constructor(private http: HttpClient) { }

    /**
    * @description
    * Obtiene todos los notices
    */
    public findAll(): Observable<any> {
        return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
    }

    /**
    * @description
    * Obtiene un notice por su code
    */
    public findByCode(code: string): Observable<any> {
        let codenotices: string = (code !== undefined && code !== null ? code + "" : "");
        return this.http.get(this.BASE.findByCode + "/" + codenotices).pipe(delay(DELAY));
    }

    /**
    * @description
    * Guarda un notice en la base de datos
    */
    public postNotice(notices: Notices): Observable<any> {
        const json = JSON.stringify(notices);
        const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
        return this.http.post(this.BASE.postNotices, json, {headers: headers}).pipe(delay(DELAY));
    }

    /**
    * @description
    * Borra un notice en la base de datos
    */
     public deleteNotices(notices: Notices): Observable<any> {
        let codenotices: string = (notices.code !== undefined && notices.code !== null ? notices.code + "" : "");
        return this.http.get(this.BASE.deleteNotices + "/" + codenotices).pipe(delay(DELAY));
    }
}